import { TextSkeleton } from 'src/modules/shared/components/atoms/text/text-skeleton';

/** Reserve the three destination rows while their availability is loading. */
export function PropertyLinkPrioritySkeleton() {
  return (
    <div
      aria-hidden
      className="divide-y divide-secondary-200 rounded-lg border border-secondary-200"
    >
      {[0, 1, 2].map((index) => (
        <div key={index} className="flex items-center gap-3 p-3">
          <div className="h-6 w-6 shrink-0 animate-pulse rounded-full bg-secondary-200" />
          <div className="min-w-0 flex-1 space-y-2">
            <div className="w-32 max-w-full">
              <TextSkeleton />
            </div>
            <div className="w-48 max-w-full">
              <TextSkeleton className="!h-3" />
            </div>
          </div>
          <div className="flex shrink-0 gap-1">
            <div className="h-8 w-8 animate-pulse rounded bg-secondary-200" />
            <div className="h-8 w-8 animate-pulse rounded bg-secondary-200" />
          </div>
        </div>
      ))}
    </div>
  );
}
